import { createReducer } from "@reduxjs/toolkit"
import { setCredit, setCreditValue, clearCredit } from "./actions"

const credits = createReducer({}, {
  [setCredit]: (_, action) => action.payload,
  [setCreditValue]: (state, action) => {state.value = action.payload},
  [clearCredit]: (state, _) => {state = null},
})

export default credits